import React, { useState, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { getBranchOwner } from "@config";
import { aiReadService, aiRegisterClient, aiTranscribeAudio } from "../../../../../api/nfse";
import { ActionButton, PillContainer } from "../../emit/components/styles";

var ANALYSIS_STEPS = [
  { text: "Lendo e preparando o documento...", subtext: "Analisando estrutura do arquivo" },
  { text: "Processando informações com Inteligência Artificial...", subtext: "Identificando detalhes da prestação de serviços" },
  { text: "Extraindo dados do Tomador, Serviços e Valores...", subtext: "Organizando CPF/CNPJ, endereços e valores" },
  { text: "Cruzando informações com cadastro fiscal e CNAEs...", subtext: "Finalizando extração inteligente" }
];

var DROPZONE_BASE = {
  border: "2px dashed #D0D5DD",
  borderRadius: "10px",
  padding: "36px 24px",
  textAlign: "center",
  cursor: "pointer",
  backgroundColor: "#F9FAFB",
  transition: "all 0.2s"
};

var DROPZONE_ACTIVE = {
  border: "2px dashed #0088cc",
  backgroundColor: "#eff8ff"
};

export default function ImportServiceWithAIModal(props) {
  var show = props.show;
  var onHide = props.onHide;
  var onApplyData = props.onApplyData;

  var fileState = useState(null);
  var file = fileState[0];
  var setFile = fileState[1];

  var fileBase64State = useState("");
  var fileBase64 = fileBase64State[0];
  var setFileBase64 = fileBase64State[1];

  var fileTypeState = useState("image");
  var fileType = fileTypeState[0];
  var setFileType = fileTypeState[1];

  var isDragActiveState = useState(false);
  var isDragActive = isDragActiveState[0];
  var setIsDragActive = isDragActiveState[1];

  var isAnalyzingState = useState(false);
  var isAnalyzing = isAnalyzingState[0];
  var setIsAnalyzing = isAnalyzingState[1];

  var isRegisteringClientState = useState(false);
  var isRegisteringClient = isRegisteringClientState[0];
  var setIsRegisteringClient = isRegisteringClientState[1];

  var autoRegisterClientState = useState(true);
  var autoRegisterClient = autoRegisterClientState[0];
  var setAutoRegisterClient = autoRegisterClientState[1];

  var currentStepIdxState = useState(0);
  var currentStepIdx = currentStepIdxState[0];
  var setCurrentStepIdx = currentStepIdxState[1];

  var extractedResultState = useState(null);
  var extractedResult = extractedResultState[0];
  var setExtractedResult = extractedResultState[1];

  var errorMessageState = useState("");
  var errorMessage = errorMessageState[0];
  var setErrorMessage = errorMessageState[1];

  


  var textInputState = useState("");
  var textInput = textInputState[0];
  var setTextInput = textInputState[1];

  var isRecordingState = useState(false);
  var isRecording = isRecordingState[0];
  var setIsRecording = isRecordingState[1];

  var isTranscribingState = useState(false);
  var isTranscribing = isTranscribingState[0];
  var setIsTranscribing = isTranscribingState[1];

  var fileInputRef = useRef(null);

  useEffect(function() {
    if (!show) {
      handleReset();
    }
  }, [show]);

  useEffect(function() {
    function handlePaste(e) {
      if (!show || isAnalyzing || extractedResult) return;
      var clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) return;
      var items = clipboardData.items;
      if (!items) return;

      for (var i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          var blob = items[i].getAsFile();
          if (blob) {
            processFile(blob);
            break;
          }
        }
      }
    }

    window.addEventListener("paste", handlePaste);
    return function() { window.removeEventListener("paste", handlePaste); };
  }, [show, isAnalyzing, extractedResult]);

  useEffect(function() {
    var interval = null;
    if (isAnalyzing) {
      setCurrentStepIdx(0);
      interval = setInterval(function() {
        setCurrentStepIdx(function(prev) {
          return prev < ANALYSIS_STEPS.length - 1 ? prev + 1 : prev;
        });
      }, 2500);
    }
    return function() {
      if (interval) clearInterval(interval);
    };
  }, [isAnalyzing]);

  function handleToggleRecording() {
    if (isRecording) {
      setIsRecording(false);
      if (window._recognitionInstance) {
        window._recognitionInstance.stop();
      }
      if (window._mediaRecorder && window._mediaRecorder.state !== "inactive") {
        window._mediaRecorder.stop();
      }
      return;
    }

    var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    
    // Se não suportar SpeechRecognition nativo (ex: Firefox sem flag), usar MediaRecorder e API de Backend
    if (!SpeechRecognition) {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setErrorMessage("Seu navegador não suporta gravação de áudio.");
        return;
      }
      
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream) {
        var mediaRecorder = new MediaRecorder(stream);
        window._mediaRecorder = mediaRecorder;
        var audioChunks = [];
        
        mediaRecorder.addEventListener("dataavailable", function(event) {
          audioChunks.push(event.data);
        });
        
        mediaRecorder.addEventListener("stop", function() {
          var audioBlob = new Blob(audioChunks, { type: "audio/webm" });
          var reader = new FileReader();
          reader.readAsDataURL(audioBlob);
          reader.onloadend = function() {
            var base64data = reader.result;
            
            // Exibir loading ou feedback...
            setIsTranscribing(true);
            
            var branch = getBranchOwner();
            aiTranscribeAudio({ audio_base64: base64data }, { branch_owner: branch ? branch.id : null })
              .then(function(response) {
                var data = (response && response.data) ? response.data : response;
                var transcribed = data.text || "";
                
                setTextInput(function(prev) {
                  return prev + (prev ? " " : "") + transcribed + " ";
                });
              })
              .catch(function(err) {
                var errMsg = "Erro ao transcrever áudio no servidor.";
                if (err && err.response && err.response.data && err.response.data.error) {
                  errMsg = err.response.data.error;
                }
                setErrorMessage(errMsg);
              })
              .finally(function() {
                setIsTranscribing(false);
              });
          };
          
          stream.getTracks().forEach(function(track) { track.stop(); });
        });
        
        mediaRecorder.start();
        setIsRecording(true);
        setErrorMessage("");
      }).catch(function(err) {
        setErrorMessage("Erro ao acessar microfone: " + err.message);
      });
      return;
    }

    var recognition = new SpeechRecognition();
    window._recognitionInstance = recognition;
    recognition.lang = 'pt-BR';
    recognition.interimResults = true;
    
    recognition.onstart = function() {
      setIsRecording(true);
      setErrorMessage("");
    };
    
    recognition.onresult = function(event) {
      var finalTranscript = '';
      
      for (var i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        }
      }
      
      if (finalTranscript) {
        setTextInput(function(prev) {
          return prev + (prev ? " " : "") + finalTranscript + " ";
        });
      }
    };
    
    recognition.onerror = function(event) {
      setIsRecording(false);
      if (event.error !== 'no-speech') {
        setErrorMessage("Erro no microfone: verifique as permissões de áudio.");
      }
    };
    
    recognition.onend = function() {
      setIsRecording(false);
    };
    
    recognition.start();
  }

  function handleReset() {
    setFile(null);
    setFileBase64("");
    setFileType("image");
    setIsDragActive(false);
    setIsAnalyzing(false);
    setCurrentStepIdx(0);
    setExtractedResult(null);
    setErrorMessage("");

    setTextInput("");
    setIsRecording(false);
    setIsTranscribing(false);
    if (window._recognitionInstance) {
      window._recognitionInstance.stop();
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }

  function processFile(selectedFile) {
    if (!selectedFile) return;

    setErrorMessage("");
    setTextInput("");

    try {
      var fileTypeStr = (selectedFile.type || "").toLowerCase();
      var fileNameStr = (selectedFile.name || "").toLowerCase();

      var isPdf = fileTypeStr === "application/pdf" || fileNameStr.indexOf(".pdf") !== -1;
      var isImage = fileTypeStr.indexOf("image/") === 0 || /\.(jpg|jpeg|png|webp)$/i.test(fileNameStr);

      if (!isPdf && !isImage) {
        setErrorMessage("Por favor, envie apenas arquivos em formato PDF ou Imagem (PNG, JPG, WEBP).");
        return;
      }

      if (selectedFile.size > 4 * 1024 * 1024) {
        setErrorMessage("O arquivo é muito grande. O tamanho máximo permitido é de 4MB.");
        return;
      }

      setFile(selectedFile);
      setFileType(isPdf ? "pdf" : "image");

      var reader = new FileReader();
      reader.onload = function(e) {
        setFileBase64(e.target.result);
      };
      reader.onerror = function() {
        setErrorMessage("Não foi possível ler o arquivo. Tente novamente.");
      };
      reader.readAsDataURL(selectedFile);
    } catch (err) {
      setErrorMessage("Erro interno ao processar arquivo: " + err.message);
    }
  }

  function handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  }

  function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  }

  function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      processFile(e.dataTransfer.files[0]);
    }
  }

  function handleFileInputChange(e) {
    if (e.target.files && e.target.files.length > 0) {
      processFile(e.target.files[0]);
    }
  }

  function handleAnalyze() {
    if (!fileBase64 && !textInput.trim()) return;
    if (isAnalyzing) return;

    setIsAnalyzing(true);
    setErrorMessage("");

    var branch_owner = getBranchOwner();
    var payload = {};
    if (fileBase64) {
        payload.file_base64 = fileBase64;
        payload.file_type = fileType;
        payload.file_name = file ? file.name : "documento";
    }
    if (textInput.trim()) {
        payload.text_content = textInput;
    }

    aiReadService(payload, { branch_owner: branch_owner })
      .then(function(response) {
        var data = (response && response.data) ? response.data : response;
        if (data && data.success) {
          setExtractedResult(data);
        } else {
          var errMsg = (data && data.error) ? data.error : "Não foi possível extrair os dados do documento.";
          setErrorMessage(errMsg);
        }
      })
      .catch(function(err) {
        var errMsg = "Ocorreu um erro ao comunicar com a inteligência artificial. Tente novamente.";
        if (err && err.response && err.response.data && err.response.data.error) {
          errMsg = err.response.data.error;
        } else if (err && err.message) {
          errMsg = err.message;
        }
        setErrorMessage(errMsg);
      })
      .finally(function() {
        setIsAnalyzing(false);
      });
  }

  function handleConfirmApply(autoEmit) {
    if (!extractedResult) return;
    if (typeof autoEmit !== "boolean") {
      autoEmit = true;
    }

    var branch = getBranchOwner();
    var shouldRegister = autoRegisterClient && !extractedResult.matched_client && extractedResult.taker && branch && branch.id;

    if (shouldRegister) {
      setIsRegisteringClient(true);
      setErrorMessage("");

    setTextInput("");

      var payload = { taker: extractedResult.taker };
      aiRegisterClient(payload, { branch_owner: branch.id })
        .then(function(response) {
          var data = (response && response.data) ? response.data : response;
          var updated = Object.assign({}, extractedResult);
          if (data && data.client && data.client.original_id) {
            updated.taker = Object.assign({}, updated.taker, data.client);
            updated.matched_client = true;
          }
          if (onApplyData) {
            onApplyData(updated, { autoEmit: autoEmit });
          }
          onHide();
        })
        .catch(function(err) {
          var errMsg = "Falha ao cadastrar cliente na base de dados.";
          if (err && err.response && err.response.data && err.response.data.error) {
            errMsg = err.response.data.error;
          } else if (err && err.message) {
            errMsg = err.message;
          }
          setErrorMessage(errMsg);
        })
        .finally(function() {
          setIsRegisteringClient(false);
        });
    } else {
      if (onApplyData) {
        onApplyData(extractedResult, { autoEmit: autoEmit });
      }
      onHide();
    }
  }

  var isPdf = fileType === "pdf";
  var taker = (extractedResult && extractedResult.taker) ? extractedResult.taker : {};
  var service = (extractedResult && extractedResult.service) ? extractedResult.service : {};
  var dropzoneStyle = Object.assign({}, DROPZONE_BASE, isDragActive ? DROPZONE_ACTIVE : {});
  var isMatchedClient = Boolean(extractedResult && extractedResult.matched_client);
  var canApply = Boolean(extractedResult && (isMatchedClient || autoRegisterClient));

  return (
    <Modal show={show} onHide={(isAnalyzing || isRegisteringClient) ? null : onHide} size="lg" centered backdrop={(isAnalyzing || isRegisteringClient) ? "static" : true}>
      <Modal.Header closeButton={!isAnalyzing && !isRegisteringClient} style={{ borderBottom: "1px solid #EAECF0", padding: "20px 24px" }}>
        <Modal.Title style={{ fontWeight: 700, color: "#101828", fontSize: "1.15rem", display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{
            background: "linear-gradient(135deg, #0088cc 0%, #005580 100%)",
            width: "38px",
            height: "38px",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            flexShrink: 0,
            boxShadow: "0 4px 10px rgba(0, 136, 204, 0.3)",
            position: "relative",
            overflow: "hidden"
          }}>
            <style>
              {`
                @keyframes ai-icon-pulse {
                  0%, 100% { transform: scale(0.9); opacity: 0.85; }
                  50% { transform: scale(1.15); opacity: 1; }
                }
                @keyframes ai-icon-spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
            <div style={{
               position: "absolute",
               width: "200%", height: "200%",
               background: "conic-gradient(transparent, rgba(255,255,255,0.35), transparent 40%)",
               animation: "ai-icon-spin 3s linear infinite"
            }} />
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ zIndex: 1, animation: "ai-icon-pulse 2s ease-in-out infinite" }}>
              <path d="M11.64 5.23a.75.75 0 0 1 1.42 0l1.24 3.73a4 4 0 0 0 2.54 2.54l3.73 1.24a.75.75 0 0 1 0 1.42l-3.73 1.24a4 4 0 0 0-2.54 2.54l-1.24 3.73a.75.75 0 0 1-1.42 0l-1.24-3.73a4 4 0 0 0-2.54-2.54l-3.73-1.24a.75.75 0 0 1 0-1.42l3.73-1.24a4 4 0 0 0 2.54-2.54l1.24-3.73Z"/>
              <path d="M19.64 1.23a.5.5 0 0 1 .95 0l.5 1.5a2 2 0 0 0 1.27 1.27l1.5.5a.5.5 0 0 1 0 .95l-1.5.5a2 2 0 0 0-1.27 1.27l-.5 1.5a.5.5 0 0 1-.95 0l-.5-1.5a2 2 0 0 0-1.27-1.27l-1.5-.5a.5.5 0 0 1 0-.95l1.5-.5a2 2 0 0 0 1.27-1.27l.5-1.5Z"/>
            </svg>
          </div>
          Preenchimento Inteligente de NFS-e com IA
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "24px" }}>

        {/* Descrição no topo do modal */}
        {!extractedResult && !isAnalyzing && (
          <div style={{
            background: "#eff8ff",
            border: "1px solid #b3d9f0",
            borderRadius: "8px",
            padding: "12px 16px",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}>
            <i className="fas fa-circle-info" style={{ color: "#0088cc", fontSize: "1.1rem", flexShrink: 0 }}></i>
            <span style={{ fontSize: "0.9rem", color: "#344054" }}>
              Importe uma proposta, ordem de serviço ou recibo em <strong>PDF ou Imagem</strong> e preencha a nota fiscal em segundos.
            </span>
          </div>
        )}

        {errorMessage && (
          <div className="alert alert-danger" style={{ borderRadius: "8px", fontSize: "0.9rem", display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
            <i className="fas fa-exclamation-circle"></i>
            <div>{errorMessage}</div>
          </div>
        )}

        {/* Estado: Analisando */}
        {isAnalyzing ? (
          <div style={{ padding: "32px 0", textAlign: "center" }}>
            <div style={{
              width: "120px",
              height: "140px",
              margin: "0 auto 24px auto",
              background: "#fff",
              border: "1px solid #EAECF0",
              borderRadius: "10px",
              padding: "14px 12px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)"
            }}>
              {[75, 90, 50, 60, 75, 50].map(function(w, idx) {
                return (
                  <div key={idx} style={{
                    height: "7px",
                    borderRadius: "4px",
                    background: "#F2F4F7",
                    width: w + "%"
                  }}></div>
                );
              })}
              {/* Scanner line */}
              <div style={{
                position: "absolute",
                left: 0,
                right: 0,
                height: "2px",
                background: "#0088cc",
                boxShadow: "0 0 10px 2px rgba(0,136,204,0.5)",
                animation: "nfse-scanner 2s ease-in-out infinite"
              }}></div>
            </div>
            <style>{"@keyframes nfse-scanner { 0% { top: 0%; } 50% { top: 95%; } 100% { top: 0%; } }"}</style>
            <strong style={{ display: "block", color: "#101828", fontSize: "1rem", marginBottom: "6px" }}>
              {ANALYSIS_STEPS[currentStepIdx].text}
            </strong>
            <span style={{ color: "#667085", fontSize: "0.875rem" }}>
              {ANALYSIS_STEPS[currentStepIdx].subtext}
            </span>
          </div>

        ) : extractedResult ? (
          /* Estado: Resultado */
          <div>
            <div style={{
              background: "#ECFDF3",
              border: "1px solid #ABEFC6",
              borderRadius: "8px",
              padding: "14px 16px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  background: "#17B26A",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}>
                  <i className="fas fa-check"></i>
                </div>
                <div>
                  <strong style={{ color: "#067647", fontSize: "0.95rem" }}>Documento Processado com Sucesso!</strong>
                  <br />
                  <span style={{ color: "#085D3A", fontSize: "0.82rem" }}>Revise os dados abaixo antes de preencher o formulário.</span>
                </div>
              </div>
              <span style={{
                background: isMatchedClient ? "#ECFDF3" : "#FEF3F2",
                color: isMatchedClient ? "#067647" : "#B42318",
                border: "1px solid " + (isMatchedClient ? "#ABEFC6" : "#FECDCA"),
                borderRadius: "20px",
                padding: "5px 14px",
                fontSize: "0.8rem",
                fontWeight: 700,
                whiteSpace: "nowrap",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px"
              }}>
                <i className={"fas fa-" + (isMatchedClient ? "user-check" : "user-xmark")} style={{ color: isMatchedClient ? "#17B26A" : "#D92D20" }}></i>
                {isMatchedClient ? "Cliente Cadastrado" : "Tomador Não Cadastrado"}
              </span>
            </div>

            {/* Tomador */}
            <div style={{ background: "#fff", border: "1px solid #EAECF0", borderRadius: "10px", padding: "16px", marginBottom: "14px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", paddingBottom: "10px", borderBottom: "1px solid #F2F4F7" }}>
                <strong style={{ color: "#101828", fontSize: "0.95rem" }}>
                  <i className="fas fa-user" style={{ color: "#0088cc", marginRight: "8px" }}></i>
                  Tomador / Cliente Identificado
                </strong>
                {taker.cpf_cnpj && (
                  <span style={{ background: "#eff8ff", color: "#0088cc", border: "1px solid #b3d9f0", borderRadius: "20px", padding: "3px 10px", fontSize: "0.78rem", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px" }}>
                    {taker.cpf_cnpj.replace(/\D/g, '').length > 11 ? "CNPJ" : "CPF"}: 
                    <input type="text" value={taker.cpf_cnpj || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {taker: Object.assign({}, taker, {cpf_cnpj: e.target.value})})); }} style={{ background: "transparent", border: "none", color: "#0088cc", fontWeight: 600, width: "120px", outline: "none" }} />
                  </span>
                )}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                <PillContainer>
                  <span className="label">Razão Social / Nome</span>
                  <input type="text" value={taker.name || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {taker: Object.assign({}, taker, {name: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Não identificado" />
                </PillContainer>
                <PillContainer>
                  <span className="label">E-mail</span>
                  <input type="text" value={taker.email || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {taker: Object.assign({}, taker, {email: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Email" />
                </PillContainer>
                <PillContainer>
                  <span className="label">Endereço</span>
                  <input type="text" value={taker.address || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {taker: Object.assign({}, taker, {address: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Logradouro" />
                </PillContainer>
                <PillContainer>
                  <span className="label">Município</span>
                  <input type="text" value={taker.city || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {taker: Object.assign({}, taker, {city: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Cidade" />
                </PillContainer>
              </div>

              {/* Destaque quando o tomador não está cadastrado */}
              {!isMatchedClient && (
                <div style={{
                  background: "#FFF4ED",
                  border: "1.5px solid #FDCF8A",
                  borderRadius: "10px",
                  padding: "16px",
                  marginTop: "14px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px"
                }}>
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                    <div style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#FEF0C7",
                      color: "#B54708",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1rem",
                      flexShrink: 0,
                      marginTop: "2px"
                    }}>
                      <i className="fas fa-user-plus"></i>
                    </div>
                    <div style={{ flex: 1 }}>
                      <strong style={{ color: "#B54708", fontSize: "0.95rem", display: "block", marginBottom: "4px" }}>
                        Tomador não localizado na base de clientes
                      </strong>
                      <p style={{ color: "#7A2E0E", fontSize: "0.85rem", margin: "0 0 12px 0", lineHeight: 1.45 }}>
                        Para emitir a nota fiscal, este tomador precisa ser cadastrado no sistema. Marque a opção abaixo para permitir o cadastro e o preenchimento automático.
                      </p>
                      <label style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        margin: 0,
                        cursor: "pointer",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        color: "#101828",
                        background: "#ffffff",
                        padding: "10px 14px",
                        borderRadius: "8px",
                        border: "1.5px solid " + (autoRegisterClient ? "#0088cc" : "#D0D5DD"),
                        boxShadow: autoRegisterClient ? "0 0 0 3px rgba(0, 136, 204, 0.15)" : "none",
                        transition: "all 0.2s"
                      }}>
                        <input
                          type="checkbox"
                          checked={autoRegisterClient}
                          onChange={function(e) { setAutoRegisterClient(e.target.checked); }}
                          style={{ width: "18px", height: "18px", accentColor: "#0088cc", cursor: "pointer" }}
                        />
                        <span>Quero cadastrar este tomador como cliente na base de dados</span>
                      </label>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Serviço */}
            <div style={{ background: "#fff", border: "1px solid #EAECF0", borderRadius: "10px", padding: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", paddingBottom: "10px", borderBottom: "1px solid #F2F4F7", flexWrap: "wrap", gap: "8px" }}>
                <strong style={{ color: "#101828", fontSize: "0.95rem" }}>
                  <i className="fas fa-receipt" style={{ color: "#0088cc", marginRight: "8px" }}></i>
                  Serviço e Discriminação
                </strong>
                <span style={{ background: "#ECFDF3", color: "#067647", border: "1px solid #ABEFC6", borderRadius: "20px", padding: "3px 12px", fontSize: "0.82rem", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px" }}>
                  R$ <input type="number" step="0.01" value={service.value || 0} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {service: Object.assign({}, service, {value: parseFloat(e.target.value) || 0})})); }} style={{ background: "transparent", border: "none", color: "#067647", fontWeight: 700, width: "80px", outline: "none" }} />
                </span>
              </div>
              <div style={{ marginBottom: "12px" }}>
                <span style={{ fontSize: "0.75rem", fontWeight: 600, color: "#667085", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  Discriminação Sugerida
                </span>
                <div style={{ marginTop: "6px" }}>
                  <textarea
                    value={service.description || ""}
                    onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {service: Object.assign({}, service, {description: e.target.value})})); }}
                    style={{
                      width: "100%",
                      minHeight: "80px",
                      fontSize: "0.88rem",
                      color: "#344054",
                      background: "#F9FAFB",
                      padding: "10px 14px",
                      borderRadius: "8px",
                      border: "1px solid #EAECF0",
                      resize: "vertical",
                      outline: "none"
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                <PillContainer>
                  <span className="label">CNAE Sugerido</span>
                  <input type="text" value={service.cnae_code || service.suggested_cnae || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {service: Object.assign({}, service, {cnae_code: e.target.value, suggested_cnae: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Ex: 0000-0/00" />
                </PillContainer>
                <PillContainer>
                  <span className="label">Item LC 116</span>
                  <input type="text" value={service.item_list_service || service.suggested_item_list_service || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {service: Object.assign({}, service, {item_list_service: e.target.value, suggested_item_list_service: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Ex: 01.01" />
                </PillContainer>
              </div>
            </div>
          </div>

        ) : (
          <div
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{ 
              display: "flex", flexDirection: "column", height: "320px", 
              justifyContent: "space-between", position: "relative",
              border: isDragActive ? "2px dashed #0088cc" : "2px dashed transparent",
              backgroundColor: isDragActive ? "#eff8ff" : "transparent",
              borderRadius: "12px", transition: "all 0.2s"
            }}
          >
            {isDragActive && (
              <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(239, 248, 255, 0.9)", zIndex: 10, borderRadius: "10px" }}>
                <strong style={{ color: "#0088cc", fontSize: "1.2rem" }}><i className="fas fa-cloud-arrow-up"></i> Solte o arquivo aqui</strong>
              </div>
            )}

            <div style={{ flex: 1, overflowY: "auto", padding: "10px 4px", display: "flex", flexDirection: "column", gap: "12px" }}>
              {!file && !textInput && !isTranscribing && (
                <div style={{ alignSelf: "flex-start", background: "#F2F4F7", padding: "14px 18px", borderRadius: "16px", borderBottomLeftRadius: "4px", maxWidth: "90%", color: "#344054", fontSize: "0.95rem" }}>
                  <p style={{ margin: "0 0 8px 0" }}>Olá! Eu sou a <strong>Inteligência Artificial do Easygestor</strong>.</p>
                  <p style={{ margin: 0 }}>Envie um <strong>recibo</strong>, <strong>proposta de serviço</strong> ou uma <strong>foto de nota</strong>. Você também pode digitar ou falar os dados da prestação de serviço. Preencherei a NFS-e para você automaticamente.</p>
                </div>
              )}

              {file && (
                <div style={{ alignSelf: "flex-end", background: "#eff8ff", padding: "12px 16px", borderRadius: "16px", borderBottomRightRadius: "4px", maxWidth: "85%", border: "1px solid #b3d9f0" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <i className={"fas fa-" + (isPdf ? "file-pdf" : "file-image")} style={{ fontSize: "1.8rem", color: isPdf ? "#D92D20" : "#0088cc" }}></i>
                    <div>
                      <strong style={{ display: "block", fontSize: "0.95rem", color: "#101828", wordBreak: "break-all" }}>{file.name}</strong>
                      <span style={{ fontSize: "0.8rem", color: "#667085" }}>{(file.size / (1024 * 1024)).toFixed(2)} MB</span>
                    </div>
                    <button type="button" onClick={handleReset} style={{ background: "transparent", border: "none", color: "#98A2B3", cursor: "pointer", marginLeft: "10px", padding: "4px" }}>
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              )}

              {isTranscribing && (
                <div style={{ alignSelf: "flex-end", background: "#F9FAFB", padding: "12px 16px", borderRadius: "16px", borderBottomRightRadius: "4px", maxWidth: "85%", color: "#667085", fontSize: "0.95rem", fontStyle: "italic" }}>
                  <i className="fas fa-spinner fa-spin" style={{ marginRight: "8px" }}></i> Transcrevendo áudio...
                </div>
              )}
            </div>

            {/* Input Bar */}
            <div style={{
              display: "flex", alignItems: "center",
              background: "#F9FAFB", border: "1px solid #EAECF0",
              borderRadius: "32px", padding: "8px 12px", gap: "8px",
              boxShadow: "0 2px 6px rgba(16, 24, 40, 0.05)"
            }}>
              <input
                type="file" ref={fileInputRef} onChange={handleFileInputChange}
                accept="application/pdf,image/png,image/jpeg,image/jpg,image/webp"
                style={{ display: "none" }}
              />
              <button 
                type="button"
                onClick={function() { if (fileInputRef.current) fileInputRef.current.click(); }}
                disabled={Boolean(file)}
                style={{ 
                  background: "transparent", border: "none", color: file ? "#D0D5DD" : "#667085", 
                  fontSize: "1.2rem", cursor: file ? "not-allowed" : "pointer", 
                  width: "36px", height: "36px", borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}
                title="Anexar arquivo"
              >
                <i className="fas fa-plus"></i>
              </button>

              <input 
                type="text" 
                value={textInput}
                onChange={function(e) { setTextInput(e.target.value); }}
                placeholder={isRecording ? "Ouvindo sua voz..." : file ? "Arquivo anexado. Clique em Enviar para analisar." : "Descreva o serviço prestado..."}
                disabled={isRecording || isTranscribing || Boolean(file)}
                style={{
                  flex: 1, background: "transparent", border: "none", outline: "none",
                  fontSize: "0.95rem", color: "#101828", minWidth: 0
                }}
                onKeyDown={function(e) {
                  if (e.key === 'Enter' && (file || textInput.trim()) && !isAnalyzing && !isRecording && !isTranscribing) {
                    handleAnalyze();
                  }
                }}
              />

              {!textInput.trim() && !file ? (
                <button 
                  type="button"
                  onClick={handleToggleRecording}
                  disabled={isTranscribing}
                  style={{ 
                    background: isRecording ? "#FEF3F2" : "transparent", 
                    border: "none", color: isRecording ? "#D92D20" : "#667085", 
                    fontSize: "1.1rem", cursor: isTranscribing ? "not-allowed" : "pointer",
                    width: "36px", height: "36px", borderRadius: "50%",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    transition: "all 0.2s"
                  }}
                  title="Ditar com voz"
                >
                  <i className={"fas fa-microphone" + (isRecording ? " fa-fade" : "")}></i>
                </button>
              ) : null}

              <button
                type="button"
                onClick={handleAnalyze}
                disabled={(!file && !textInput.trim()) || isAnalyzing || isRecording || isTranscribing}
                style={{
                  background: (!file && !textInput.trim()) || isRecording || isTranscribing ? "#F2F4F7" : "#0088cc",
                  border: "none", color: (!file && !textInput.trim()) || isRecording || isTranscribing ? "#98A2B3" : "#fff",
                  width: "36px", height: "36px", borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  cursor: (!file && !textInput.trim()) || isRecording || isTranscribing ? "not-allowed" : "pointer",
                  transition: "all 0.2s"
                }}
                title="Enviar para análise"
              >
                <i className="fas fa-paper-plane" style={{ fontSize: "0.95rem", marginLeft: "-2px" }}></i>
              </button>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #EAECF0", padding: "16px 24px", justifyContent: "space-between" }}>
        <ActionButton variant="secondary" onClick={onHide} disabled={isAnalyzing || isRegisteringClient}>
          Cancelar
        </ActionButton>

        {extractedResult && (
          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "flex-end" }}>
            {!canApply && (
              <span style={{
                color: "#B42318",
                fontSize: "0.82rem",
                fontWeight: 600,
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                background: "#FEF3F2",
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #FECDCA"
              }}>
                <i className="fas fa-circle-exclamation"></i>
                Marque o cadastro do tomador para prosseguir
              </span>
            )}
            <ActionButton variant="secondary" onClick={handleReset} disabled={isRegisteringClient}>
              <i className="fas fa-rotate-left"></i>
              Ler Outro Documento
            </ActionButton>
            <ActionButton variant="secondary" onClick={function() { handleConfirmApply(false); }} disabled={!canApply || isRegisteringClient} title="Preencher os campos do formulário para revisão manual antes de emitir">
              <i className="fas fa-file-pen"></i>
              Apenas Preencher Formulário
            </ActionButton>
            <ActionButton variant="primary" onClick={function() { handleConfirmApply(true); }} disabled={!canApply || isRegisteringClient}>
              <i className={"fas fa-" + (isRegisteringClient ? "circle-notch fa-spin" : "bolt")}></i>
              {isRegisteringClient ? "Cadastrando e Transmitindo..." : "Emitir NFS-e com IA"}
            </ActionButton>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/components/ImportServiceWithAI/index.jsx